import React, { useContext, useEffect, useState } from 'react'
import { MeetingPageContext } from './MeetingPage'
import API from '../../../services/API'
import { GlobalContext } from '../../../App'
import BigModal from '../../../components/Modals/BigModal'
import AnDateTimePicker from '../../../components/DateTime/DateTimePicker'
import Autocomplete from '@mui/material/Autocomplete'
import Avatar from '@mui/material/Avatar'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Grid from '@mui/material/Grid'
import TextField from '@mui/material/TextField'
import Typography from '@mui/material/Typography'
import { Stack } from '@mui/material'

const MeetingDetails = () => {
  const { openMeetingDetails, setOpenMeetingDetails, meeting, setMeeting } =
    useContext(MeetingPageContext)
  const { setToast } = useContext(GlobalContext)

  const [inviteeOptions, setInviteeOptions] = useState([])

  const [title, setTitle] = useState('')
  const [meetingType, setMeetingType] = useState('')
  const [startTime, setStartTime] = useState(null)
  const [endTime, setEndTime] = useState(null)
  const [location, setLocation] = useState('')
  const [invitees, setInvitees] = useState([])

  useEffect(() => {
    if (meeting) {
      setTitle(meeting.title ?? '')
      setMeetingType(meeting.meetingType ?? '')
      setStartTime(meeting.startTime ?? null)
      setEndTime(meeting.endTime ?? null)
      setLocation(meeting.location ?? '')
      setInvitees(meeting.invitees ?? [])
    }
  }, [meeting])

  useEffect(() => {
    API.post('/users-in-team')
      .then((res) => res.status === 200 && setInviteeOptions(res.data))
      .catch((e) => console.log(e))
  }, [])

  const handleSubmit = (e) => {
    e.preventDefault()
    const data = {
      title,
      meetingType,
      startTime,
      endTime,
      location,
      invitees: invitees.map((x) => x._id),
    }
    API.patch(`/governance/meetings/${meeting._id}`, data).then((res) => {
      if (res.status === 200) {
        setToast({ message: 'Meeting Updated' })
        setOpenMeetingDetails(false)
        setMeeting((prev) => ({ ...prev, ...data, invitees }))
      } else {
        setToast({ message: 'Unable to update meeting', severity: 'error' })
      }
    })
  }

  return (
    <BigModal
      open={openMeetingDetails}
      onClose={() => setOpenMeetingDetails(false)}
    >
      <Grid container spacing={2} component="form" onSubmit={handleSubmit}>
        <Grid item xs={12}>
          <Typography variant="title2">Meeting Details</Typography>
        </Grid>
        <Grid item xs={12} lg={8}>
          <TextField
            label="Meeting Title"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            fullWidth
            autoComplete="off"
          />
        </Grid>
        <Grid item xs={12} lg={4}>
          <Autocomplete
            disableClearable
            value={meetingType}
            onChange={(e, value) => setMeetingType(value)}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Meeting Type"
                helperText="Type in your own option if not listed"
              />
            )}
            options={['Governance', 'Operational', 'Event Planning', 'Other']}
            freeSolo
          />
        </Grid>
        <Grid item xs={12} md={6} xl={3}>
          <AnDateTimePicker
            label="Start Time"
            date={startTime}
            onChange={(newDate) => setStartTime(newDate)}
            fullWidth
          />
        </Grid>
        <Grid item xs={12} md={6} xl={3}>
          <AnDateTimePicker
            label="End Time"
            fullWidth
            date={endTime}
            onChange={(newDate) => setEndTime(newDate)}
          />
        </Grid>
        <Grid item xs={12} xl={6}>
          <TextField
            value={location}
            onChange={(e) => setLocation(e.target.value)}
            label="Location"
            fullWidth
            autoComplete="off"
          />
        </Grid>
        <Grid item xs={12}>
          <Autocomplete
            value={invitees}
            options={inviteeOptions}
            getOptionLabel={(opt) => opt?.firstName + ' ' + opt?.lastName}
            multiple
            renderTags={(options) => (
              <Box display="flex" gap={1}>
                {options.map((opt) => {
                  if (opt) {
                    return (
                      <Box
                        display="flex"
                        gap={1}
                        key={opt?._id ?? 1}
                        border="solid 1px rgba(0,0,0,0.24)"
                        borderRadius={1}
                        padding={1}
                      >
                        <Avatar
                          src={opt?.photograph}
                          sx={{ width: 24, height: 24 }}
                        />
                        <Typography>
                          {opt?.firstName} {opt?.lastName}
                        </Typography>
                      </Box>
                    )
                  }
                })}
              </Box>
            )}
            renderOption={(props, option) => {
              const { key, ...rest } = props
              return (
                <Box key={key} display="flex" gap={1} {...rest}>
                  <Avatar
                    src={option?.photograph}
                    sx={{ width: 24, height: 24 }}
                  />
                  <Typography>
                    {option?.firstName} {option?.lastName}
                  </Typography>
                </Box>
              )
            }}
            onChange={(e, value) => setInvitees(value)}
            isOptionEqualToValue={(option, value) =>
              typeof value === 'string'
                ? option === value
                : option._id === value._id
            }
            renderInput={(params) => <TextField {...params} label="Invitees" />}
          />
        </Grid>
        <Grid item xs={12}>
          <Stack direction={{ xs: 'column', lg: 'row' }} spacing={2}>
            <Button
              size="small"
              color="error"
              variant="contained"
              fullWidth={{ xs: true, lg: false }}
              onClick={() => window.location.reload()}
            >
              Cancel
            </Button>
            <Button
              type="submit"
              size="small"
              color="success"
              variant="contained"
              fullWidth={{ xs: true, lg: false }}
            >
              Submit
            </Button>
          </Stack>
        </Grid>
      </Grid>
    </BigModal>
  )
}

export default MeetingDetails
